import { ExtendedIntegrationType, IntegrationCredentials, IntegrationDesignSystem, } from "@supernova-studio/model";
import { z } from "zod";
export const DTOIntegrationCredentials = IntegrationCredentials.omit({
    accessToken: true,
    refreshToken: true,
});
export const DTOIntegration = z.object({
    id: z.string(),
    workspaceId: z.string(),
    type: ExtendedIntegrationType,
    createdAt: z.coerce.date(),
    integrationCredentials: z.array(DTOIntegrationCredentials).optional(),
    integrationDesignSystems: z.array(IntegrationDesignSystem).optional(),
});
export const DTOIntegrationOAuthGetResponse = z.object({
    url: z.string(),
});
export const DTOIntegrationPostResponse = z.object({
    integration: DTOIntegration,
});
export const DTOIntegrationsGetListResponse = z.object({
    integrations: DTOIntegration.array(),
});
